import React from "react";
import { Container } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import '../css/contacts.css';

const Contacts = () => {
    return (
        <Container>
            <h1 className="section-title">Наши контакты</h1>
            <div className="contacts-grid">
                <div className="contact-card">
                    <div className="contact-icon">
                        <FaPhone />
                    </div>
                    <h3>Телефон</h3>
                    <p><a href="tel:+79122652545">+7 912 265-25-45</a></p>
                    <p><a href="tel:+73433722535">+7 (343) 372-25-35</a></p>
                    <p><a href="tel:+79222092535">+7 922 209-25-35</a></p>
                </div>

                <div className="contact-card">
                    <div className="contact-icon">
                        <FaEnvelope />
                    </div>
                    <h3>Email</h3>
                    <p><a href="mailto:89122652545@mail.ru">89122652545@mail.ru</a></p>
                    <p><a href="mailto:udc1@bk.ru">udc1@bk.ru</a></p>
                </div>

                <div className="contact-card">
                    <div className="contact-icon">
                        <FaMapMarkerAlt />
                    </div>
                    <h3>Адрес</h3>
                    <p>Большой Исток, Ключевая 41</p>
                </div>

                <div className="contact-card">
                    <div className="contact-icon">
                        <FaClock />
                    </div>
                    <h3>Режим работы</h3>
                    <p>Пн-Пт: 9:00 - 18:00<br />
                    Сб-Вс: По записи</p>
                </div>
            </div>
        </Container>
    );
}

export default Contacts;